// ── EmailClaudePanel (Evo Brain — panel 6) ───────────────────────────────────
// Ya no renderiza UI propia — el shell genérico vive en AssistantDock (ver
// contexts/AssistantContext.tsx). Conserva lo propio de email: el bloqueo de
// links de phishing/spam en la respuesta (SafeLink, vía renderAssistantContent)
// y el panel de análisis de followup arriba del chat.
//
// El composer (redactar un email nuevo) vive en ComposeClaudePanel.tsx, no
// acá — mismo dock, pero con composeContext + módulo 'contact' cuando el
// destinatario matchea (ver EmailPage.tsx). compose-chat/quick-action
// bespoke fueron eliminados.

import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SafeLink } from '../SafeLink.js';
import { FollowupAnalysisPanel } from './FollowupAnalysisPanel.js';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';
import { useEmailDetail } from '../../hooks/useEmail.js';

interface Props {
  messageId: number | null;
}

export function EmailClaudePanel({ messageId }: Props) {
  const { t } = useTranslation();
  const { data: emailData } = useEmailDetail(messageId);
  const isRiskyEmail = emailData?.detail.classifiedAs === 'Phishing' || emailData?.detail.classifiedAs === 'Spam Sugerido';

  const entityId = messageId != null ? String(messageId) : null;
  useAssistantModule('email_message', entityId, undefined);

  useRegisterAssistantActive('email_message', entityId, {
    title: t('email.assistant.title'),
    placeholder: messageId != null ? t('email.assistant.placeholder') : t('email.assistant.placeholderDisabled'),
    inputDisabled: messageId == null,
    emptyHint: t('email.assistant.hint'),
    entityLink: messageId != null
      ? { label: emailData?.detail.subject ?? `#${messageId}`, href: `/email?id=${messageId}` }
      : null,
    topContent: messageId != null && emailData?.detail.direction === 'inbound' ? (
      <div className="px-3 pt-3">
        <FollowupAnalysisPanel messageId={messageId} detail={emailData.detail} />
      </div>
    ) : undefined,
    renderAssistantContent: content => (
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => <SafeLink href={href} isBlocked={isRiskyEmail}>{children}</SafeLink>,
        }}
      >
        {content}
      </Markdown>
    ),
  });

  return null;
}
